"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/statistic/style");

var _statistic = _interopRequireDefault(require("antd/es/statistic"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _lodash = require("lodash");

var _Login = _interopRequireDefault(require("cornerstone_ui_core/lib/components/Login"));

var _logging = _interopRequireDefault(require("cornerstone_ui_core/lib/services/logging.service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Countdown = _statistic.default.Countdown;

var App = /*#__PURE__*/function (_React$Component) {
  _inherits(App, _React$Component);

  var _super = _createSuper(App);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "clearTimeout", function () {
      if (_this.warnTimeout) clearTimeout(_this.warnTimeout);
    });

    _defineProperty(_assertThisInitialized(_this), "resetTimeout", function () {
      if ((0, _lodash.isEmpty)(_this.warningModal)) {
        _this.clearTimeout();

        _this.eventTriggered();

        _this.setTimeout();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "eventTriggered", function () {
      localStorage.setItem("tab-active", "tab-active" + Math.random());
    });

    _defineProperty(_assertThisInitialized(_this), "warn", function () {
      if ((0, _lodash.isEmpty)(_this.warningModal)) {
        _this.warningModal = _modal.default.warning({
          title: "Warning",
          content: /*#__PURE__*/_react.default.createElement("div", null, "You will be logged out automatically in", /*#__PURE__*/_react.default.createElement(Countdown, {
            title: "",
            value: Date.now() + 1000 * 60 * 5,
            onFinish: _this.logout,
            format: "mm:ss"
          })),
          onOk: function onOk() {
            _this.closeTimeOutWindow();

            _this.resetTimeout();
          },
          onCancel: function onCancel() {
            _this.closeTimeOutWindow();

            _this.resetTimeout();
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "logout", function () {
      //clear localStorage
      sessionStorage.clear();
      localStorage.removeItem("sessionId");
      localStorage.removeItem("jwtToken"); // Send a logout request to the API

      if (localStorage.getItem("AppId") === "SCS" || localStorage.getItem("AppId") === "RDS") {
        _this.loginModalOpen = true;

        _this.closeTimeOutWindow();

        _this.resetTimeout();

        return _this.loginModal.open().then(function () {
          _this.loginModalOpen = false;

          _this.setTimeout();
        }).catch(function (err) {
          return console.log(err);
        });
      }

      _this.props.logout && _this.props.logout();

      _this.destroy(); // Cleanup

    });

    _defineProperty(_assertThisInitialized(_this), "closeTimeOutWindow", function () {
      if (!(0, _lodash.isEmpty)(_this.warningModal)) {
        _this.warningModal.destroy();

        _this.warningModal = "";
        if (localStorage.getItem("AppId") !== "FEP") (0, _logging.default)("Timeout canceled", "INFO");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "destroy", function () {
      _this.clearTimeout();

      !(0, _lodash.isEmpty)(_this.warningModal) && _this.warningModal.destroy();
      localStorage.removeItem("logout-event");
      localStorage.removeItem("logout-triggered");
      window.removeEventListener("storage", _this.logoutAfterTimeout);

      for (var i in _this.events) {
        window.removeEventListener(_this.events[i], _this.resetTimeout);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "logoutAfterTimeout", function (event, that) {
      if (event.key === "tab-active") {
        //Avoid time out if another window is active
        _this.closeTimeOutWindow();

        _this.clearTimeout();

        _this.setTimeout();

        localStorage.removeItem("tab-active");
      }

      if (event.key === "logout-triggered") {
        that.props.logout && that.props.logout();
      }
    });

    _this.events = ["load", "mousemove", "mousedown", "click", "scroll", "keypress"];
    _this.state = {};
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();

      if (localStorage.getItem("loginModalOpen")) {
        this.logout();
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;

      this.warningModal = "";
      this.setTimeout = this.setTimeout.bind(this);

      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeout);
      }

      window.addEventListener("storage", function (event) {
        return _this2.logoutAfterTimeout(event, _this2);
      });
      this.setTimeout();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroy(); // Cleanup
    }
  }, {
    key: "setTimeout",
    value: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      if (!this.loginModalOpen) {
        var storedTimeout = localStorage.getItem("timeout");
        var timeout = storedTimeout ? storedTimeout : 15;
        this.warnTimeout = setTimeout(this.warn, (timeout - 5) * 60 * 1000);
      }
    })
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Login.default, _extends({
        key: 1,
        modalProps: {
          className: "promise-modal",
          title: "Login",
          closable: false,
          maskClosable: false
        }
      }, this.props, {
        ref: function ref(_ref) {
          return _this3.loginModal = _ref;
        }
      })), children);
    }
  }]);

  return App;
}(_react.default.Component);

exports.default = App;